import React from "react";

const Register = () => {
  return <h1>Register Page</h1>;
};

export default Register;
